import { Fragment, memo, ReactElement } from 'react';
import ActiveStep from './active-step';

interface FormNewPersonProps {
  step?: number;
  isEdit?: boolean;
  typeRegister?: string;
}

const FormNewPersonComponent = ({
  step,
  isEdit = false,
  typeRegister,
}: FormNewPersonProps): ReactElement => {
  return (
    <Fragment>
      <ActiveStep step={step} isEdit={isEdit} typeRegister={typeRegister} />
    </Fragment>
  );
};

FormNewPersonComponent.displayName = 'New person - Form component';

const FormNewPerson = memo(FormNewPersonComponent);

export default FormNewPerson;
